export default `
  :root {
      /* # Inputs */
      /* ## Sizing and Styling */
      --wuk-input-default-height-wuk: 60px;
      --wuk-input-default-padding-wuk: 1.25em;
      --wuk-radio-box-size-wuk: 2.25em;
      --wuk-ruler-box-width-wuk: 3.125em;
      --wuk-ruler-box-height-wuk: 3.125em;
      --wuk-radio-inset-shadow-size-wuk: 0.5625em;
      --wuk-input-radius-wuk: 6px;

      /* # Buttons */
      /* ## Sizing and Styling */
      --wuk-min-button-width-wuk: 12.5rem;
      --wuk-button-font-size-wuk: 1.25rem;
      --wuk-button-border-thickness-wuk: 2px;
      --wuk-button-height-base-wuk: 1.45rem;
  }
`;
